import * as XLSX from 'xlsx'

export const exportToExcel = async (data, fileName = 'export.xlsx') => {
  const ws = XLSX.utils.json_to_sheet(data)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Dane')

  if ('showSaveFilePicker' in window) {
    const handle = await window.showSaveFilePicker({
      suggestedName: fileName,
      types: [
        {
          description: 'Excel',
          accept: {
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
          }
        }
      ]
    })
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const writable = await handle.createWritable()
    await writable.write(wbout)
    await writable.close()
  } else {
    XLSX.writeFile(wb, fileName)
  }
}
